import { useQuery, UseQueryResult } from "@tanstack/react-query";
import config from "../config.json";
import { IPageable, Params } from "../types/table/interfaces.type";
import { IProfile } from "./ProfileService";
import { createAxiosInstance } from "./ServicesHelpers";

const axiosInstance = createAxiosInstance(config.BALANCE_API_BASE_URL);

export interface BalanceType {
  id: string;
  profileId: string;
  clientUsage: number;
  vendorUsage: number;
  clientPayment: number;
  vendorPayment: number;
  clientInitialBalance: number;
  vendorInitialBalance: number;
  balance: number;
}

export async function fetchBalances(
  params: Params<BalanceType>
): Promise<IPageable<BalanceType>> {
  try {
    const response = await axiosInstance.get("/balances", { params });
    return response.data;
  } catch (error: any) {
    throw new Error(
      error.response?.data?.message ||
        "An error occurred while getting the balances."
    );
  }
}
export async function fetchBalance(
  id: BalanceType["id"]
): Promise<BalanceType> {
  try {
    const response = await axiosInstance.get(`/balances/${id}`);
    return response.data;
  } catch (error: any) {
    throw new Error(
      error.response?.data?.message ||
        `An error occurred while getting balance/${id}.`
    );
  }
}
export async function fetchBalanceByProfileId(
  profileId: IProfile["id"]
): Promise<BalanceType | undefined> {
  try {
    const balances = await fetchBalances({ profileId });
    return balances.content[0];
  } catch (error: any) {
    throw new Error(
      error.response?.data?.message ||
        `An error occurred while getting balance for profileId=${profileId}.`
    );
  }
}

export const useBalanceQuery = (
  params: Params<BalanceType>
): UseQueryResult<IPageable<BalanceType>, Error> => {
  const queryKey = ["balance", JSON.stringify(params)];
  return useQuery({
    queryKey,
    queryFn: () => fetchBalances(params),
  });
};
